<div class="alert-content" mat-dialog-content>
    <div class="red-alert-title">{{title}}</div>
    <p>{{text}}</p>
</div>
<mat-dialog-actions class="red-alert-actions">
    <button mat-button class="mat-primary" tabindex="-1" (click)="cancel()">{{noButtonText}}</button>
    <button mat-button class="mat-primary" tabindex="-1" (click)="confirm()">{{yesButtonText}}</button>
</mat-dialog-actions>
